import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { url } from '@datacamp/exercise-library-utils';
import config from '../config';
export class RemoteDesktopApiClient {
  constructor(environment) {
    _defineProperty(this, "environment", void 0);
    this.environment = environment;
  }
  get endpoint() {
    return config(this.environment).urls.REMOTE_DESKTOP_API;
  }
  async getUnapprovedLicenses(courseId) {
    const response = await fetch(url(this.endpoint, 'api', 'course', String(courseId), 'unapproved_licenses'), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (response.status === 404) {
      return [];
    }
    if (response.status === 200) {
      return response.json();
    }
    throw new Error("getUnapprovedLicenses status ".concat(response.status));
  }
  async acceptLicenses(licenseIds) {
    const result = await fetch(url(this.endpoint, 'api', 'licenses', 'approve'), {
      body: JSON.stringify({
        ids: licenseIds
      }),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST'
    });
    return result.status === 201;
  }
}